import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isForbidden = (response: HttpErrorResponse): boolean => {
  return response.status === HttpStatusCode.Forbidden;
};
